module.exports = __webpack_public_path__ + "assets/acoustic-drums.93e0cb2b.wav";